import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import Message from '../../../component/Message'
import langM from './lang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import localstorage from 'src/helper/localstorage'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang:langM.en,
    language:'en',
    applyList:[],
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    
    if (language == 'en') {
      setDocumentTitle("Join Application")
    }else if (language == 'ar') {
      setDocumentTitle("انضم إلى التطبيق")
    }else if (language == 'tr') {
      setDocumentTitle("Uygulamaya Katıl")
    }
    
    // end
    let uid = await setUidToken(this.props.location.query)
    this.getList(uid)
  }
  //获取审核列表
  getList = async(uid)=>{
    let { hostSystemId  } =  localstorage.get('updataInfo')
    let res = await http.post('/web/hostsystem/apply/list',{hostSystemId,uid})
    if (res.code == 0 && res.res) {
      this.setState({applyList:res.res})
    }
  }
  agree = async (uid,id) => {
    let { hostSystemId  } =  localstorage.get('updataInfo')
    let res = await http.post('/web/hostsystem/apply/confirm', { hostSystemId, uid, status: 4,id })
    if (res.code == 0) {
      this.getList()
      this.refs.msg.show(this.state.lang.sesmsg)
    } else {
      this.refs.msg.show(this.state.lang.have)
      this.getList()
    }
  }
  reject = async (uid,id) => {
    let { hostSystemId  } =  localstorage.get('updataInfo')
    let res = await http.post('/web/hostsystem/apply/confirm', { hostSystemId, uid, status: 2 ,id})
    if (res.code == 0) {
      this.getList()
      this.refs.msg.show(this.state.lang.sesmsg)
    } else  {
      this.refs.msg.show(this.state.lang.have)
      this.getList()
    }
  }

  render() {
    let { lang , applyList, language } = this.state
    return (
      <div  className={`join-application ${language == 'ar'?'in-tr':''}` }>

         <div className='list-root-join-application'>
           {applyList.length>0 && applyList.map((item,index)=>(<div className='list-item' key={index}>
            <div className='list-item-left'>
              <div className='user-img'>
                <img className='user-arroot' src={item.InviteeAvatarurl}></img>          
                {item.InviteeGender == 1 && <img className="user-gender" src='/img/app/tradeUnion/man_icon.png'></img>}
                {item.InviteeGender == 2 && <img className="user-gender" src='/img/app/tradeUnion/women_icon.png'></img>}
              </div>
              <div className='user-info'>
                <div className='user-info-top'>{item.InviteeNickname}</div>
                <div className='user-info-buttom'>{lang.id}:{item.InviteeDuid}</div>
              </div>
            </div>
            <div className='list-item-rigth'>
              {item.status ==1 && <div className='accept' onClick={()=>this.reject(item.inviteUid*1,item.id)}>{lang.reject}</div>}
              {item.status ==1 &&  <div className='reject' onClick={()=>this.agree(item.inviteUid*1,item.id)}>{lang.accept}</div>}
              {item.status ==4 && <div className='under-review'>{lang.underreview}</div>}
              {item.status ==2 && <div className='under-review'>{lang.rejected}</div>}
              {item.status ==3 &&<div className='under-review'>{lang.agreed}</div>}
            </div>
           </div>) ) }  
           
        </div>
        {applyList.length == 0 && (<div className='empty'>{lang.emptyText}</div>)}
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/join-application/index.js